import { ReactComponentManifest } from "web/entrypoints/common/setup";
import CollectionBar from "web/react/components/collection-bar/collection-bar";
import FeedControls from "web/react/components/feed-controls/feed-controls";
import FeedGenderSwitch from "web/react/components/feed-gender-switch/feed-gender-switch";
import FeedSwitchTabOverlay from "web/react/components/feed-switch-tab-overlay/feed-switch-tab-overlay";
import FeedsSeoContent from "web/react/components/feeds-seo-content/feeds-seo-content";
import FeedsShowMoreContainer from "web/react/components/feeds-show-more-container/feeds-show-more-container";
import FilterContainer from "web/react/components/filter-container/filter-container";
import FollowStickyBanner from "web/react/components/follow-sticky-banner/follow-sticky-banner";
import Footer from "web/react/components/footer/footer";
import RelatedRail from "web/react/components/related-rail/related-rail";
import RelatedSearchesRail from "web/react/components/related-searches-rail/related-searches-rail";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    CollectionBar,
    FeedControls: withRedux(FeedControls),
    FeedGenderSwitch: withRedux(FeedGenderSwitch),
    FeedSwitchTabOverlay,
    FeedsSeoContent,
    FeedsShowMoreContainer: withRedux(FeedsShowMoreContainer),
    FilterContainer: withRedux(FilterContainer),
    FollowStickyBanner,
    Footer,
    RelatedRail,
    RelatedSearchesRail,
};

export default components;
